export default {
  title: 'Become a Kilimall Seller',
  question: 'Do you have a Kilimall consumer Account ?',
  hasAccount: 'I already have a consumer account',
  hasAccountDesc: 'Select this option to log in with your existing consumer account. The newly registered merchant account will be directly linked to this Global User account.',
  noAccount: 'I do not have a consumer account yet',
  noAccountDesc: 'Select this option to create a new Global User account, and the merchant role will be activated simultaneously.',
  oauthStateInvalid: 'Authorization failed. Please try again.',
  oauthCodeMissing: 'Authorization code missing. Please try again.'
}
